import { defaultsConfig } from "~config/sport/defaults";
import { handballUiConfig } from "~config/sport/handballUi.ts";
import { FixtureStatuses } from "~enums/fixtureStatuses";
import { PeriodTypes } from "~enums/periodTypes.ts";
import { Roles } from "~enums/roles";
import { RosterPosition } from "~enums/rosterPosition";
import { UniformItemBottomTypes } from "~enums/uniformItemBottomTypes";
import { UniformItemColors } from "~enums/uniformItemColors.ts";
import { UniformItemTopTypes } from "~enums/uniformItemTopTypes";
import { UniformItemTypes } from "~enums/uniformItemTypes";
import type { SportConfiguration } from "~types/sportConfiguration";

const seasonOfficialRoles: Array<Roles> = [
  Roles.Referee,
  Roles.AssistantReferee1,
  Roles.AssistantReferee2,
  Roles.Secretary,
  Roles.Timekeeper,
  Roles.RefereeObserver,
  Roles.HandballScorer,
  Roles.Scout1,
  Roles.Scout2,
  Roles.Scout3,
  Roles.MatchSupervisor,
  Roles.ScoutSupervisor,
  Roles.Delegate,
];

const fixtureOfficialRoles: Array<Roles> = [Roles.Referee, Roles.AssistantReferee2, Roles.Secretary, Roles.Timekeeper];

const staffRoles: Array<Roles> = [
  Roles.Coach,
  Roles.CoachAssistant,
  Roles.Delegate,
  Roles.MatchLiaison,
  Roles.MediaOfficer,
  Roles.Physiotherapist,
  Roles.CoachGoalKeeper,
  Roles.CoachAthletics,
  Roles.Director,
  Roles.Committee,
  Roles.Doctor,
  Roles.General,
  Roles.Manager,
  Roles.OfficeStaff,
  Roles.Other,
  Roles.RefereeObserver,
  Roles.SportDirector,
  Roles.TeamCoordinator,
  Roles.VideoTechnician,
  Roles.YouthCoordinator,
];

const uniforms: SportConfiguration["uniforms"] = {
  bottomOptions: [UniformItemBottomTypes.Shorts],
  items: [
    {
      titleIntlKey: "uniform.player",
      topType: [UniformItemTopTypes.ShortSleeve],
      itemTypes: {
        [UniformItemTypes.Top]: [UniformItemColors.Primary, UniformItemColors.Secondary],
        [UniformItemTypes.Bottom]: [UniformItemColors.Primary],
        [UniformItemTypes.Socks]: [UniformItemColors.Primary],
      },
    },
    {
      titleIntlKey: "uniform.goalkeeper",
      topType: [UniformItemTopTypes.LongSleeve],
      itemTypes: {
        [UniformItemTypes.GoalkeeperTop]: [UniformItemColors.Primary, UniformItemColors.Secondary],
        [UniformItemTypes.GoalkeeperBottom]: [UniformItemColors.Primary],
        [UniformItemTypes.Socks]: [UniformItemColors.Primary],
      },
    },
  ],
};

const rosterPositions: Array<RosterPosition> = [
  RosterPosition.CenterBackcourt,
  RosterPosition.DefensiveSpecialist,
  RosterPosition.Goalkeeper,
  RosterPosition.LeftBackcourt,
  RosterPosition.LeftWingman,
  RosterPosition.Pivot,
  RosterPosition.RightBackcourt,
  RosterPosition.RightWingman,
];

export const handballConfig: SportConfiguration = {
  ...defaultsConfig,
  fixtureStatuses: [...defaultsConfig.fixtureStatuses, FixtureStatuses.WarmUp, FixtureStatuses.OnPitch, FixtureStatuses.AboutToStart],
  uniforms,
  seasonOfficialRoles,
  fixtureOfficialRoles,
  seasonStaffRoles: staffRoles,
  fixtureStaffRoles: staffRoles,
  rosterPositions,
  uiConfiguration: handballUiConfig,
  periods: {
    [PeriodTypes.Period1]: { intlKey: "period.period1" },
    [PeriodTypes.Period2]: { intlKey: "period.period2" },
    [PeriodTypes.ExtraPeriod0]: { intlKey: "period.extraTime1.period1" },
    [PeriodTypes.ExtraPeriod1]: { intlKey: "period.extraTime1.period2" },
    [PeriodTypes.ExtraPeriod2]: { intlKey: "period.extraTime2.period1" },
    [PeriodTypes.ExtraPeriod3]: { intlKey: "period.extraTime2.period2" },
    [PeriodTypes.ExtraPeriod4]: { intlKey: "period.shootout" },
  },
};
